import { render } from "./edit-remark-modal.vue?vue&type=template&id=d68fb0b8"
import script from "./edit-remark-modal.vue?vue&type=script&lang=js"
export * from "./edit-remark-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__